import API from '@/api'
const getCauseOfDisputeData = async (): Promise<any> => {
  return await API.PenaltyMasterRepository.getCauseOfDisputeData()
}

export default getCauseOfDisputeData
